import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { fetchThemeConfig } from '../apis/md/customization/jsonConfigs';
import { THEME_CONFIG_KEYS } from '@lemontaps/lib/constants';
import { useAppTranslation } from './useAppTranslation';
import { useAppSelector } from '@/application/hooks';

export default function usePrivateThemeConfig<T extends object>(
  key: string | null,
  options?: { language?: string | null; unitId?: number | null; fetchThemeLevel?: boolean },
) {
  const { getAccessTokenSilently } = useAuth0();
  const { activeLanguage } = useAppTranslation();

  const lang = typeof options?.language === 'string' ? options.language : activeLanguage;

  const [config, setConfig] = useState<T | null>(null);
  const [error, setError] = useState(false);
  const domainVerified = useAppSelector(state => state.login.domainVerified);
  useEffect(() => {
    if (!domainVerified) return;
    if (key && Object.values(THEME_CONFIG_KEYS).includes(key as THEME_CONFIG_KEYS)) {
      fetchThemeConfig<T>(getAccessTokenSilently, {
        key: key as THEME_CONFIG_KEYS,
        language: lang,
        unitId: options?.unitId,
        fetchThemeLevel: options?.fetchThemeLevel,
      })
        .then(({ value }) => setConfig(value))
        .catch(() => setError(true));
    } else if (key) {
      setError(true);
    }
  }, [
    lang,
    getAccessTokenSilently,
    key,
    options?.unitId,
    options?.fetchThemeLevel,
    domainVerified,
  ]);

  return { config, error, loading: Boolean(key && !config && !error) };
}
